<template>
  <div class="js-basedata-faultcode app-container">
    <app-search>
      <div slot="content">
        <el-form
          inline
          :model="listQuery"
          label-suffix="："
          :label-width="$t('system.brand.brandLabelWidth')"
        >
          <el-form-item
            :label="$t('system.brand.series.seriesName')"
            :label-width="$t('system.brand.brandLabelWidth')"
          >
            <el-input
              v-model="listQuery.seriesName"
              :placeholder="$t('system.brand.series.seriesName')"
              clearable
            />
          </el-form-item>
        </el-form>
      </div>
      <!-- 清空查询按钮 -->
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 授权按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-filter="showfilter = true"
      @click-add="handleAdd"
      @click-update="handleUpdate"
      @click-delete="handleDelete"
      @click-search="listLoad"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
        :scroll-line="8"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      border
      fit
      highlight-current-row
      style="width: 100%"
      :row-class-name="tableRowClassName"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      @row-click="rowClick"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{
            scope.$index + 1 + (listQuery.pageNum - 1) * listQuery.pageSize
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :min-width="item.width"
      >
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row[item.prop] || "/" }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        :label="$t('system.brand.series.carModel')"
        width="100px"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <el-button
              type="primary"
              size="mini"
              @click="goToCarModel(scope.row)"
            >
              {{ $t("public.view") }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-row>
      <el-col
        :span="20"
        :class="[total > 0 ? 'visible' : 'hidden', 'pagination-container']"
      >
        <!-- 分页 -->
        <el-pagination
          :current-page="listQuery.pageNum"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.pageSize"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-col>
      <!-- 返回上一级 -->
      <el-col :span="4" class="pagination-container">
        <el-button class="fr" type="primary" size="mini" @click="goBack">
          {{ $t("system.brand.series.goBackBrand") }}
        </el-button>
      </el-col>
    </el-row>

    <!-- 新增编辑dialog弹窗 -->
    <add-update-dialog
      :visibles.sync="addUpdateVisible"
      :is-edit="isEdit"
      :data="isEdit ? tableRow : { brandId }"
      @add-complete="addComplete"
      @update-complete="updateComplete"
    />
  </div>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { getPageButton } from '@/mixins/getButton'
// 组件
import AddUpdateDialog from './components/addUpdateDialog'
// request
import { listUrl, deleteUrl, TYPENUMBER } from '@/api/system/carSeries'

export default {
  name: 'carSeries',
  components: { AddUpdateDialog },
  mixins: [pagingMixin, partialForm, otherHeight, tableStyle, getPageButton],
  props: {
    brandId: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      listQuery: {
        brandId: this.brandId
      },
      showfilter: false,
      tableList: [
        { value: this.$t('system.brand.brand.brandName'), prop: 'brandName', sortable: 'custom', position: 'center', width: '120px', checked: true },
        { value: this.$t('system.brand.series.seriesName'), prop: 'seriesName', sortable: 'custom', position: 'center', width: '100px', checked: true },
        { value: this.$t('system.brand.series.seriesCode'), prop: 'seriesCode', sortable: 'custom', position: 'center', width: '140px', checked: true },
        { value: this.$t('system.brand.remark'), prop: 'remark', sortable: 'custom', position: 'center', width: '100px', checked: true },
      ],
      authouizeList: [],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      addUpdateVisible: false,
      isEdit: false,
      tableRow: {}
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }
  },
  methods: {
    // 获取选中行的索引
    tableRowClassName({ row, rowIndex }) {
      row.$rowIndex = rowIndex
    },
    // 加载数据
    listLoad() {
      this.listLoading = true
      this.$http.post(listUrl, this.listQuery).then(({ data }) => {
        this.list = []
        if (data.code === 0) {
          this.tableRow = {}
          this.list = data.data || []
          this.total = data.total
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    // 点击行
    rowClick(row) {
      this.tableRow = { ...row }
    },
    // 判断是否选中
    tableRowIsSlect() {
      const { $rowIndex } = this.tableRow
      return !($rowIndex === undefined)
    },
    // 新增
    handleAdd() {
      this.isEdit = false
      this.addUpdateVisible = true
    },
    // 新增成功
    addComplete() {
      this.listLoad()
    },
    // 编辑
    handleUpdate() {
      if (this.tableRowIsSlect()) {
        this.isEdit = true
        this.addUpdateVisible = true
      } else {
        this.$alert(this.$t('public.updateTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
          .then(() => { })
          .catch(() => { })
      }
    },
    // 编辑成功
    updateComplete() {
      this.listLoad()
    },
    // 删除
    handleDelete() {
      if (!this.tableRowIsSlect()) {
        this.$alert(this.$t('public.deleteTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return
      }
      const deleteData = {
        id: this.tableRow.seriesId,
        type: TYPENUMBER
      }
      this.$confirm(this.$t('public.deleteItemTips'), this.$t('public.tips'), {
        confirmButtonText: this.$t('public.define'),
        cancelButtonText: this.$t('public.cancel'),
        type: 'warning'
      })
        .then(() => {
          this.$http.delete(deleteUrl, { data: deleteData }).then(({ data }) => {
            if (data.code === 0) {
              if (this.list && this.list.length === 1) {
                this.listQuery.pageNum =
                  this.listQuery.pageNum > 1
                    ? this.listQuery.pageNum - 1
                    : this.listQuery.pageNum
                this.listLoad()
              } else {
                this.list.splice(this.tableRow.$rowIndex, 1)
                this.tableRow = {}
              }
              this.total--
              this.$message.success({
                message: this.$t('public.deleteSuccess'),
                duration: 2 * 1000
              })
            }
          })
        })
        .catch(() => { })
    },
    // 查看车型
    goToCarModel(row) {
      const postData = { TYPENUMBER: TYPENUMBER + 1, ...row }
      this.$emit('change-type', postData)
    },
    // 返回
    goBack() {
      this.$emit('change-type', { TYPENUMBER: TYPENUMBER - 1 })
    }
  }
}
</script>

<style lang='scss' scoped>
.fr {
  margin: 3px 12px 3px 0;
  float: right;
}
</style>
